import { Modal } from 'react-bootstrap'

type UnitUnavailableModalProps = {
  show: boolean
  onClose: () => void
}

const UnitUnavailableModal = ({ show, onClose }: UnitUnavailableModalProps) => (
  <Modal
    size="sm"
    aria-labelledby="unit-unavailable-title"
    centered
    backdrop="static"
    keyboard
    show={show}
    onHide={onClose}
    dialogClassName="custom-modal mw-600px"
    className="bg-black bg-opacity-50"
  >
    <Modal.Header>
      <Modal.Title id="unit-unavailable-title" className="flex-root d-flex justify-content-center">
        <h2 className="fd-uppercase">Unidade indisponível</h2>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="w-100">
        <div className="pb-10 pb-lg-15 text-center">
          <span className="fw-bold me-5 text-justify fs-3 text-gray-800">
            A unidade que você acessou não está mais disponível.
          </span>
        </div>
        <button
          type="button"
          className="btn btn-lg fw-bold btn-primary w-100"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </Modal.Body>
  </Modal>
)

export default UnitUnavailableModal
